<template>
  <div class="content">
    <div class="block block-rounded block-fx-shadow mb-3">
      <div class="block-header">
        <h3 class="block-title">{{ $t('options.address_types') }}</h3>
        <div class="block-options">
            <b-btn v-b-modal.addType size="sm" variant="primary" class="float-right">{{ $t('options.add_type') }}</b-btn>
        </div>
      </div>
      <table class="table table-hover table-bordered bg-white table-striped">
        <thead>
          <th>№</th>
          <th>{{ $t('options.name') }}</th>
          <th>{{ $t('options.status') }}</th>
          <th>{{ $t('options.color') }}</th>
          <th>{{ $t('app.desc') }}</th>
          <th>{{ $t('options.created_at') }}</th>
          <th>{{ $t('options.updated_at') }}</th>
          <th>{{ $t('app.action') }}</th>
        </thead>
        <tbody>
          <template v-if="!isProcessing">
            <tr v-for="(address_type, index) in address_types"  :key="address_type.id">
              <td>{{index+1}}</td>
              <td>{{address_type.name}}</td>
              <td>{{address_type.status == 1 ? $t('options.shown'): $t('options.hided') }}</td>
              <td :style="{ backgroundColor: address_type.color }"></td>
              <td>{{address_type.description}}</td>
              <td>{{address_type.created_at| datetimeFormat }}</td>
              <td>{{address_type.updated_at| datetimeFormat }}</td>
              <td>
                <div class="btn-group" role="group" aria-label="btnGroup1">
                  <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm">
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </button>
                  <button @click.prevent="handleDelete(address_type.id)" class="btn btn-danger btn-sm ">
                    <i class="fa fa-times-circle"></i>
                  </button>
                </div>
              </td>
            </tr>
          </template>
          <tr v-if="isProcessing">
            <td colspan="10" class="text-center">
              <div class='sk-wave'>
                <div class='sk-rect sk-rect-1'></div>
                <div class='sk-rect sk-rect-2'></div>
                <div class='sk-rect sk-rect-3'></div>
                <div class='sk-rect sk-rect-4'></div>
                <div class='sk-rect sk-rect-5'></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal
      id="addType"
      size="lg"
      :title="$t('options.add_type_title')"
      ref="modalAddStatus"
      @ok="handleStore"
      :ok-title="$t('buttons.ok')"
      :cancel-title="$t('buttons.cancel')"
      @ok-disabled="isProcessing"
    >
        <div class="form-group">
          <label for="storename" class="col-form-label">{{ $t('options.name') }}</label>
          <input type="text" class="form-control" v-model="type.name" :class="{'is-invalid': errors.name }" id="storename">
          <span v-if="errors.name" class="invalid-feedback">
              <strong>{{ errors.name ? errors.name[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="storestatus" class="col-form-label">{{ $t('options.status') }}</label>
          <select v-model="type.status" class="form-control" id="storestatus" :class="{'is-invalid': errors.status }">
            <option selected="true" value="" disabled>{{ $t('placeholder.select_status') }}</option>
            <option value="1">{{ $t('options.show') }}</option>
            <option value="0">{{ $t('options.hide') }}</option>
          </select>
          <span v-if="errors.status" class="invalid-feedback">
              <strong>{{ errors.status ? errors.status[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="storecolor" class="col-form-label">{{ $t('options.color') }}</label>
          <b-form-input type="color" v-model="type.color" id="storecolor" ></b-form-input>
        </div>
        <div class="form-group">
          <label for="storedeck" class="col-form-label">{{ $t('app.desc') }}</label>
          <textarea class="form-control" v-model="type.description" id="storedeck" rows="3"></textarea>
        </div>
    </b-modal>

    <b-modal
      size="lg"
      :title="$t('options.edit_type_title')"
      ref="modalUpdateStatus"
      @ok="handleUpdate"
      :ok-title="$t('buttons.ok')"
      :cancel-title="$t('buttons.cancel')"
      @ok-disabled="isProcessing"
    >
        <div class="form-group">
          <label for="updatename" class="col-form-label">{{ $t('options.name') }}</label>
          <input type="text" class="form-control" v-model="update_type.name" :class="{'is-invalid': update_errors.name }" id="updatename">
          <span v-if="update_errors.name" class="invalid-feedback">
              <strong>{{ update_errors.name ? update_errors.name[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="updatestatus" class="col-form-label">{{ $t('options.status') }}</label>
          <select v-model="update_type.status" class="form-control" id="updatestatus" :class="{'is-invalid': update_errors.status }">
            <option selected="true" value="" disabled>{{ $t('placeholder.select_status') }}</option>
            <option value="1">{{ $t('options.show') }}</option>
            <option value="0">{{ $t('options.hide') }}</option>
          </select>
          <span v-if="update_errors.status" class="invalid-feedback">
              <strong>{{ update_errors.status ? update_errors.status[0] : '' }}</strong>
          </span>
        </div>
        <div class="form-group">
          <label for="updatecolor" class="col-form-label">{{ $t('options.color') }}</label>
          <b-form-input type="color" v-model="update_type.color" id="updatecolor" ></b-form-input>
        </div>
        <div class="form-group">
          <label for="updatedeck" class="col-form-label">{{ $t('app.desc') }}</label>
          <textarea class="form-control" v-model="update_type.description" id="updatedeck" rows="3"></textarea>
        </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      address_types: [],
      type: {
        name: '',
        color: '#305AA2',
        status: '',
        icon: '',
        description: '',
      },
      update_type: [],
      errors: {},
      update_errors: {},
      message: '',
      isProcessing: false,
    };
  },
  mounted() {
    this.fetchAddressStatuses();
  },
  methods: {
    fetchAddressStatuses() {
      this.isProcessing = true;
      window.axios.get('/admin/options/address/types')
        .then((res) => {
          this.address_types = res.data.types;
          this.isProcessing = false;
        });
    },

    clearModal() {
      this.type.name = '';
      this.type.color = '';
      this.type.status = '';
      this.type.icon = '';
      this.type.description = '';
      this.errors = {};
    },

    clearUpdateModal() {
      this.update_type = {};
      this.update_errors = {};
    },

    initUpdate(index) {
      this.update_errors = {};
      this.$refs.modalUpdateStatus.show();
      this.update_type = this.address_types[index];
    },

    handleStore(evt) {
      evt.preventDefault();
      this.storeType();
      this.isProcessing = true;
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.updateType();
      this.isProcessing = true;
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteType(id);
        }
      });
    },

    storeType() {
      window.axios.post('/admin/options/address/type', this.type)
        .then((res) => {
          if (res.status === 201) {
            this.$refs.modalAddStatus.hide();
            this.clearModal();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchAddressStatuses();
          }
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updateType() {
      window.axios.put(`/admin/options/address/type/${this.update_type.id}`, this.update_type)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.modalUpdateStatus.hide();
            this.clearUpdateModal();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchAddressStatuses();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deleteType(id) {
      window.axios.delete(`/admin/options/address/type/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchAddressStatuses();
          }
          this.isProcessing = false;
        });
    },
  },
};
</script>
